import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import { goToPage } from '../cellcomEnergySlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Lottie from 'react-lottie';
import CheckedAnimation from '../../../../animations/approved-checked-outline.json';
import Config from '../../../../Config';
import ThemedLottie from '../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../utilities/theme/ThemeColorEnum';

const SuccessPage = (props) => {

  return (
    <div className="cellcom-energy-page-wrapper">
        <div className="cellcom-energy-page">
          <div className="gray-container">

              <div className="result-page">
                  <div className="success-icon">
                      {/* <Lottie options={{animationData: CheckedAnimation, loop: false}} width={100} height={100} /> */}
                      <ThemedLottie animationData={CheckedAnimation} color={ThemeColorEnum.PRIMARY} width={100} height={100} loop={false} />
                  </div>
                  <div className="result-text-bold"> מעולה! </div>
                  <div className="result-text-bold"> קיבלנו את הפרטים שלך </div>
                  <div className="result-text"> ברגע שנדע שאפשר לנייד את המונה שלך ל{window.Config.brand_Name_HE} Energy נעדכן אותך </div> 
              </div>
              <div className="btn-wrapper"> <BtnSubmit text={'חזור'} onclick={handleSuccessPageClick} /> </div>

          </div>
        </div>        
    </div>
  );

  function handleSuccessPageClick() {
    window.location.href = Config.staticWebSiteUrl;
  } 

};

const mapStateToProps = (state) => {
  return {
    page: state.cellcomEnergyBlock.page,
  };
};

const mapDispatchToProps = {
  goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);